(() => {
  const buttonClick = (event) => {
    event.preventDefault();

    const accordionButton = event.target;
    const accordionItems = accordionButton.closest('.accordion-flexible').querySelectorAll('.js-accordion-flexible__item');
    const currentItem = accordionButton.closest('.js-accordion-flexible__item');

    if (currentItem.classList.contains('accordion-flexible__item--active')) {
      return hide(currentItem);
    }

    Array.from(accordionItems).map((accordionItem) => hide(accordionItem));

    if (currentItem.classList.contains('accordion-flexible__item--active')) {
      hide(currentItem);
    } else {
      show(currentItem);
    }
  };

  const hide = (element) => {
    element.classList.remove('accordion-flexible__item--active');
    element.querySelector('.accordion-flexible__button').setAttribute('aria-expanded', 'false');

    element.querySelector('.accordion-flexible__body').setAttribute('aria-hidden', 'true');
  };

  const show = (element) => {
    element.classList.add('accordion-flexible__item--active');

    element.querySelector('.accordion-flexible__button').setAttribute('aria-expanded', 'true');

    element.querySelector('.accordion-flexible__body').setAttribute('aria-hidden', 'false');
  };

  const initialize = (accordion) => {
    const element = accordion.element;
    const options = JSON.parse(accordion.options);

    if (options.open) {
      show(element.querySelector('.js-accordion-flexible__item'));
    }

    Array.from(element.querySelectorAll('.js-accordion-button')).map((button) => {
      button.addEventListener('click', buttonClick);
    });
  };

  const accordionFlexible = stp.setup('accordion-flexible');

  accordionFlexible.map(initialize);
})();
